import $ from 'jquery';
/**
 * Enables the "navigation" functionality.
 */
const enableNavigationFunctionality = () => {
    const currentPath = _trimHref(window.location.pathname);
    // Highlights the current navigation link
    $('.nav-item').each(function () {
        const $link = $('a', this);
        if (_trimHref($link.attr('href')) === currentPath) {
            $link.addClass('active');
        }
    });
    // Toggles the nested nav menu
    $('.subnav-toggle').on('click', function (e) {
        e.preventDefault();
        const $parent = $(this).parent().parent();
        $parent.toggleClass('is-open');
    });
    /**
     * Trims the query string from a URL.
     * @param url - The URL.
     * @returns The URL without the query string.
     */
    function _trimHref(url = '') {
        return url.replace(/\?.*$/, '');
    }
};
export default enableNavigationFunctionality;
